import styled from "@emotion/styled";
import { Box, Paper } from "@mui/material";
import { HHNTheme } from "hhn-commons";

export const ReferralModalContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 450px;
  background-color: ${HHNTheme.common.white};
  border-radius: 4px;
`;

export const TagStyle = styled.span`
  border-radius: 3px;
  background-color: ${HHNTheme.primary};
  color: ${HHNTheme.common.white};
  padding: 1px 5px;
  font-weight: bold;
  font-size: small;
  height: 20px;
  margin-left: 5px;
`;

export const ReferralModalHeader = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${HHNTheme.primary};
  padding: 10px 15px;
  border-radius: 4px 4px 0 0;
`;

export const ReferralButtonStyle = styled(Box)`
  display: flex;
  flex-direction: row;
  padding: 8px 20px;
  width: 100%;
  justify-content: center;
`;

export const GroupTitleBar = styled(Box)`
  display: flex;
  align-items: center;
  margin: 10px 15px;
`;

export const GroupAbout = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
`;

export const GroupName = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ModalBody = styled(Box)`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const ModalActions = styled(Box)`
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const ModalActionsContainer = styled(Paper)`
  margin: 15px;
  background: ${HHNTheme.contentBackground};
`;
